/** Nombre fijo del label (PNG) que se imprime al documentar una maleta vía SSBD. */
export const DEFAULT_LABEL_NAME = 'StandBySSBD1';
/** Número de copias fijas a imprimir por cada bagtag. */
export const DEFAULT_LABEL_COPIES = 1;

/**
 * Nombres de los labels (PNG) SSBD según el escenario de la reservación/pasajero
 * al momento de documentar la maleta. La selección entre estos se resuelve vía
 * resolveSsbdLabelName() (ver @app/utils/functions/ssbd-bagtag). Si ninguno
 * aplica, no debe imprimirse ningún label.
 */
export const SSBD_LABEL_STANDBY = DEFAULT_LABEL_NAME;
export const SSBD_LABEL_CONNECTION = 'ConnectionSSBD1';
export const SSBD_LABEL_PRIORITY = 'PrioritySSBD1';
/** Caballero Águila (AM, ffTierLevel 'TTP') sin conexión: label propio, no el Priority genérico. */
export const SSBD_LABEL_PRIORITY_CABALLERO_AGUILA = 'PriorityCASSBD1';
/** Conexión + Priority genérico o Caballero Águila (ver resolveSsbdBagtagScenario). */
export const SSBD_LABEL_PRIORITY_CONNECTION = 'PriorityConectionSSBD1';

/**
 * nombre de archivo confirmado por diseño, condición
 * de negocio aún sin definir.
 */
export const SSBD_LABEL_SHORT_CONNECTION = 'ShortConectionSSBD01';

/**
 * Niveles de viajero frecuente (ffTierLevel) que califican como Priority
 * "genérico", agrupados por `ffProgram`. Gold (GLD) y Caballero Águila (TTP)
 * quedan fuera: Caballero Águila usa su propio catálogo (ver
 * SSBD_CABALLERO_AGUILA_FF_TIER_LEVELS_BY_PROGRAM).
 *
 * PENDIENTE: SkyTeam y LATAM Pass aún sin catálogo.
 */
export const SSBD_PRIORITY_FF_TIER_LEVELS_BY_PROGRAM: Record<string, string[]> = {
  AM: ['PLT', 'TTN'],
  DL: ['DLG', 'DLP', 'DLD'],
};

/** Niveles de viajero frecuente que califican como Caballero Águila, agrupados por `ffProgram`. */
export const SSBD_CABALLERO_AGUILA_FF_TIER_LEVELS_BY_PROGRAM: Record<string, string[]> = {
  AM: ['TTP'],
};
/**
 * Header por el que se informa al servicio SSBD qué impresora física usar,
 * resuelta dinámicamente desde GET /printers (ver SsbdPrinterService.getPrinters).
 * No hay un nombre fijo válido: el nombre real depende del driver instalado en
 * cada kiosko, por lo que se descubre en runtime en vez de hardcodearse.
 */
export const PRINTER_NAME_HEADER = 'x-printer-name';
/** Status que indica que una impresora reportada por /printers no está disponible. */
export const PRINTER_OFFLINE_STATUS = 'offline';

/**
 * Nombre de la impresora física preferida para el flujo SSBD. Al resolver la
 * impresora disponible vía getPrinters() (ver SsbdPrinterService.pickAvailablePrinter),
 * se busca primero esta impresora entre las disponibles; si no se encuentra
 * (porque el kiosko tiene el driver registrado con otro nombre, o no está
 * instalada), se usa la primera impresora disponible como respaldo.
 */
export const PREFERRED_PRINTER_NAME = 'EPSON CW-C4000u';
/**
 * Tiempo máximo (ms) de espera por cada llamada al microservicio local de
 * impresión SSBD. Evita que una petición colgada deje suscripciones abiertas;
 * al vencer se trata como un fallo no bloqueante del flujo de pesaje.
 */
export const SSBD_PRINTER_REQUEST_TIMEOUT_MS = 10000;
